import { themeColors } from '../themeColors';
import BackButton from "@/components/Common/BackButton";
/**
 * @file   src\pages\InventoryAllSentIntroductions.js
 * @brief  This file is responsible for handling inventry wise sent introductions list.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import React, { useState, useEffect } from "react";
import { getUserId } from "../helpers/common";
import { useLocation, useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";
import {
  getMyAcceptedIntroductionByInvId,
  getMyPendingIntroductionByInvId,
  cancelIntroduction,
  getIntroductionWantAdDetailsByIntroId,
} from "../services/introductionService";
import { usePrevious } from "../hooks/usePrevious";
import ViewWantAdModal from "../components/Introduction/ViewWantAdModal";
import { toast } from "react-toastify";
import AgentProfileViewModal from "../components/Introduction/AgentProfileViewModal";
import { updateIntroduction } from "../helpers/message";
import PendingSendIntroductionList from "../components/Introduction/PendingSendIntroductionList";
import AcceptedSendIntroductionList from "../components/Introduction/AcceptedSendIntroductionList";
import { PageWrapper } from '@/components/PageWrapper';

const InventoryAllSentIntroductions = (props) => {

  const navigate = useNavigate();
  const location = useLocation();
  const [showViewWantAdModal, setViewWantAdModal] = useState(false);
  const ViewWantAdModalClose = () => setViewWantAdModal(false);

  const [showProfileModal, setProfileModal] = useState(false);
  const ProfileModalClose = () => setProfileModal(false);

  const [selectedUserId, setSelectedUserId] = useState(0);
  const [wantAdViewInventoryId, setWantAdViewInventoryId] = useState(0);

  const [showAcceptIntroductionModal, setAcceptIntroductionModal] =
    useState(false);
  const AcceptIntroductionModalShow = () => setAcceptIntroductionModal(true);
  const [pendingList, setPendingList] = useState([]);
  const [acceptedList, setAcceptedList] = useState([]);
  const [pendingListPage, setPendingListPage] = useState(1);
  const [acceptedListPage, setAcceptedListPage] = useState(1);
  const [pendingListCount, setPendingCount] = useState(0);
  const [acceptedListCount, setAcceptedCount] = useState(0);
  const pendingScrollSection = "pending";
  const acceptedScrollSection = "accepted";
  const [scrollSection, setScrollSection] = useState(pendingScrollSection);
  const INTRO_LIST_PAGE_LIMIT = 4;
  const inventoryId = location.state && location.state["inventoryId"];
  const title = location.state && location.state["title"];

  const [wantAdDetails, setWantAdDetails] = useState([]);

  const updateIntroPageOnScroll = (section) => {
    setScrollSection(section);
    if (section === pendingScrollSection) {
      setPendingListPage((prevState) => prevState + 1);
    } else if (section === acceptedScrollSection) {
      setAcceptedListPage((prevState) => prevState + 1);
    }
  };

  const prevPending = usePrevious(pendingListPage);
  const prevAccepted = usePrevious(acceptedListPage);

  useEffect(() => {
    if (!inventoryId) {
      navigate(pageURLs.home);
    }
    const userId = getUserId();
    if (!prevPending && !prevAccepted) {
      getPendingIntroductions(pendingListPage, inventoryId, userId);
      getAcceptdIntroductions(acceptedListPage, inventoryId, userId);
    } else if (prevPending !== pendingListPage) {
      getPendingIntroductions(pendingListPage, inventoryId, userId);
    } else if (prevAccepted !== acceptedListPage) {
      getAcceptdIntroductions(acceptedListPage, inventoryId, userId);
    }
  }, [pendingListPage, acceptedListPage]);

  /**
   * To get pending introductions list
   * @param {*} page
   * @param {*} inventoryId
   * @param {*} userId
   */
  const getPendingIntroductions = async (page, inventoryId, userId) => {
    const reqPayload = {
      inventoryId: inventoryId,
      page: page,
      limit: INTRO_LIST_PAGE_LIMIT,
    };
    await getMyPendingIntroductionByInvId(reqPayload).then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);
        const count = _.get(response, "result.Count", "");
        if (response.errorCode === 0) {
          setPendingList([...pendingList, ...list]);
          setPendingCount(count);
        } else {
          console.log(`####error`);
        }
      }
    });
  };
  /**
   * To get accepted introductions list
   * @param {*} page
   * @param {*} inventoryId
   * @param {*} userId
   */
  const getAcceptdIntroductions = async (page, inventoryId, userId) => {
    const reqPayload = {
      inventoryId: inventoryId,
      page: page,
      limit: INTRO_LIST_PAGE_LIMIT,
    };
    await getMyAcceptedIntroductionByInvId(reqPayload).then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);
        const count = _.get(response, "result.Count", "");
        if (response.errorCode === 0) {
          setAcceptedList([...acceptedList, ...list]);
          setAcceptedCount(count);
        } else {
          console.log(`####error`);
        }
      }
    });
  };
  /**
   * To handle cancel introducion
   * @param {*} introductionId
   */
  const onClickCancelIntroduction = async (introductionId) => {
    const reqPayload = {
      introductionId: introductionId,
    };
    await cancelIntroduction(reqPayload).then(async (response) => {
      if (response) {
        if (response.errorCode == 0) {
          let data = {
            isdeleted: true,
          };

          let updateresponse = await updateIntroduction(introductionId, data);

          toast.success(response.message);
          setPendingList((current) =>
            current.filter((lst) => lst.IntroductionId !== introductionId)
          );
        } else {
          console.log(`####error`);
        }
      }
    });
  };
  /**
   * To handle view want ad
   * @param {*} introductionId
   */
  const ViewWantAd = async (introductionId) => {
    setWantAdViewInventoryId(introductionId);
    const reqPayload = {
      introductionId: introductionId,
    };
    await getIntroductionWantAdDetailsByIntroId(reqPayload).then((response) => {
      if (response) {
        if (response.errorCode == 0) {
          setWantAdDetails(response.result);
          setViewWantAdModal(true);
        } else {
          console.log(`####error`);
        }
      }
    });
  };

  const ViewProfile = (agentId) => {
    setViewWantAdModal(false);
    setSelectedUserId(agentId);
    setProfileModal(true);
  };

  const closeAgentModal = () => {
    ViewWantAd(wantAdViewInventoryId);
    setProfileModal(false);
  };

  return (
    <>

      <PageWrapper>
        <div className="m-0">
          <div className="main-content p-0 agent-no-login-content">
            <div className="row m-0">
              <div className="col-md-12">
                <div className="edit-want-ad-wrap introduction-wrap mw-697">
                  <BackButton text="Back" onClick={() => navigate(`${pageURLs.inventoryDetails}/${inventoryId}`)} />
                  <h3>
                    All introductions – <span>{title}</span>
                  </h3>
                  <div className="payments-wrap intro-content-block">
                    <PendingSendIntroductionList
                      list={pendingList}
                      count={pendingList.length}
                      acceptedCount={acceptedList.length}
                      updateIntroPageOnScroll={updateIntroPageOnScroll}
                      CancelIntroduction={(introductionId) => {
                        onClickCancelIntroduction(introductionId);
                      }}
                      ViewWantAd={(id) => {
                        ViewWantAd(id);
                      }}
                    />
                    <AcceptedSendIntroductionList
                      list={acceptedList}
                      count={acceptedList.length}
                      updateIntroPageOnScroll={updateIntroPageOnScroll}
                      AcceptIntroductionModalShow={AcceptIntroductionModalShow}
                      ViewWantAd={(id) => {
                        ViewWantAd(id);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageWrapper>

      <ViewWantAdModal
        show={showViewWantAdModal}
        onHide={ViewWantAdModalClose}
        wantAdDetails={wantAdDetails}
        ViewProfileModal={(agentId) => {
          ViewProfile(agentId);
        }}
      />

      <AgentProfileViewModal
        show={showProfileModal}
        onHide={ProfileModalClose}
        userId={selectedUserId}
        onClose={() => {
          closeAgentModal();
        }}
      />
    </>
  );
};

export default InventoryAllSentIntroductions;
